import { configureStore } from '@reduxjs/toolkit';
import updatePineDataReducer from './uploadPineSlice';
import translationReducer from './translationSlice';

const store = configureStore({
  reducer: {
    updatePineData: updatePineDataReducer,
    translation: translationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
});

export default store;